module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Kisoft.ai - Premium Talents","short_name":"Kisoft","start_url":"/","background_color":"#ffffff","theme_color":"#07d259","display":"minimal-ui","icon":"src/images/logo_only.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"05f16fbfdc65d380676c5348119041e3"},
    },{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"siteId":"5","matomoUrl":"https://um.kisoft.me","siteUrl":"https://kisoft.ai","matomoPhpScript":"matomo.php","matomoJsScript":"matomo.js","trackPageView":true,"requireConsent":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
